import { render, staticRenderFns } from "./PostulateProject.vue?vue&type=template&id=7519f9a5&scoped=true"
import script from "./PostulateProject.vue?vue&type=script&lang=js"
export * from "./PostulateProject.vue?vue&type=script&lang=js"
import style0 from "./PostulateProject.vue?vue&type=style&index=0&id=7519f9a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7519f9a5",
  null
  
)

export default component.exports